// layout/PublicLayout.jsx
import React from 'react';
import Navbar from '../components/public/Navbar';
import Footer from '../components/public/Footer';

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-16">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
